export const en = {
    'new-video': 'New video'
};
